module.exports = __webpack_public_path__ + "img/unlock.6c3da096.svg";